import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '../../../node_modules/@angular/router';
import { MenuItem } from '../models/menu-item';
import { BehaviorSubject, Subject } from 'rxjs';
import { EnviromentService } from '../services/enviroment.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnChanges {


  @Input() items:MenuItem[];
  @Input() sideNavExtended:boolean;
  @Output() expandChange = new EventEmitter<boolean>();
  menuRoot:string;
  public showExpanded: Subject<boolean> = new BehaviorSubject(false);
  public version = null;
  constructor(
    private userService:UserService,
    private router: Router,
    private enviromentService: EnviromentService
  ) { 
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.sideNavExtended && changes.sideNavExtended.currentValue !== changes.sideNavExtended.previousValue) {
        this.showExpanded.next(changes.sideNavExtended.currentValue);
      }
    }
  }
  screenWidth: number;
  
  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.enviromentService.getVersion().subscribe(version => {
      this.version = version.version;
    })
  }
  isLoggedIn():boolean{
    return (this.userService.isLoggedIn());
  }    
  logout(){
    this.userService.logout();
    this.router.navigate(['']);
  }
  onSinenavToggle(){
    this.sideNavExtended = !this.sideNavExtended;
    this.expandChange.emit(this.sideNavExtended);    
  }
  onSetExtended(isExtended:boolean){
    this.sideNavExtended =isExtended;
    this.expandChange.emit(this.sideNavExtended);    
  }  
}
